// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"107":"07fb916f","201":"a84bd690","244":"3dfeaf38","347":"8b71bc04","807":"3efe2b88"}[chunkId] + ".css";
};